import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

const Home = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [stats, setStats] = useState({
    users: 0,
    products: 0,
    productImages: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [userRes, productRes, imageRes, sliderRes, inquiryRes, aboutRes] =
          await Promise.all([
            api.post("/user/get"),
            api.post("/product/get"),
            api.post("/product_image/get_data"),
            api.post("/slider/get"),
            api.post("/profile/get"),
            api.post("/about/get"),
          ]);
        setStats({
          users: userRes.data.user.length,
          products: productRes.data.product.length,
          productImages: imageRes.data.product.length,
          sliders: sliderRes.data.slider.length,
          inquires: inquiryRes.data.Profile.length,
          abouts: aboutRes.data.about.length,
        });
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchStats();
  }, []);
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="tf-section-4 mb-30">
            {/* <!-- chart-default --> */}
            <Link
              to="/product"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="wg-chart-default">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap14">
                    <div className="image type-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="52"
                        viewBox="0 0 48 52"
                        fill="none"
                      >
                        <path
                          d="M19.1094 2.12943C22.2034 0.343099 26.0154 0.343099 29.1094 2.12943L42.4921 9.85592C45.5861 11.6423 47.4921 14.9435 47.4921 18.5162V33.9692C47.4921 37.5418 45.5861 40.8431 42.4921 42.6294L29.1094 50.3559C26.0154 52.1423 22.2034 52.1423 19.1094 50.3559L5.72669 42.6294C2.63268 40.8431 0.726688 37.5418 0.726688 33.9692V18.5162C0.726688 14.9435 2.63268 11.6423 5.72669 9.85592L19.1094 2.12943Z"
                          fill="#22C55E"
                        />
                      </svg>
                      <i className="icon-layers"></i>
                    </div>
                    <div>
                      <div className="body-text mb-2">Total Product</div>
                      <h4>{stats.products}</h4>
                    </div>
                  </div>
                </div>
                <div className="wrap-chart">
                  <div id="line-chart-1"></div>
                </div>
              </div>
            </Link>

            <Link
              to="/product-images"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="wg-chart-default">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap14">
                    <div className="image type-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="52"
                        viewBox="0 0 48 52"
                        fill="none"
                      >
                        <path
                          d="M19.1094 2.12943C22.2034 0.343099 26.0154 0.343099 29.1094 2.12943L42.4921 9.85592C45.5861 11.6423 47.4921 14.9435 47.4921 18.5162V33.9692C47.4921 37.5418 45.5861 40.8431 42.4921 42.6294L29.1094 50.3559C26.0154 52.1423 22.2034 52.1423 19.1094 50.3559L5.72669 42.6294C2.63268 40.8431 0.726688 37.5418 0.726688 33.9692V18.5162C0.726688 14.9435 2.63268 11.6423 5.72669 9.85592L19.1094 2.12943Z"
                          fill="#FF5200"
                        />
                      </svg>
                      <i className="icon-image"></i>
                    </div>
                    <div>
                      <div className="body-text mb-2">Total Product Images</div>
                      <h4>{stats.productImages}</h4>
                    </div>
                  </div>
                </div>
                <div className="wrap-chart">
                  <div id="line-chart-2"></div>
                </div>
              </div>
            </Link>

            <Link
              to="/sliders"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="wg-chart-default">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap14">
                    <div className="image type-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="52"
                        viewBox="0 0 48 52"
                        fill="none"
                      >
                        <path
                          d="M19.1094 2.12943C22.2034 0.343099 26.0154 0.343099 29.1094 2.12943L42.4921 9.85592C45.5861 11.6423 47.4921 14.9435 47.4921 18.5162V33.9692C47.4921 37.5418 45.5861 40.8431 42.4921 42.6294L29.1094 50.3559C26.0154 52.1423 22.2034 52.1423 19.1094 50.3559L5.72669 42.6294C2.63268 40.8431 0.726688 37.5418 0.726688 33.9692V18.5162C0.726688 14.9435 2.63268 11.6423 5.72669 9.85592L19.1094 2.12943Z"
                          fill="#a200ffff"
                        />
                      </svg>
                      <i className="icon-book"></i>
                    </div>
                    <div>
                      <div className="body-text mb-2">Total sliders</div>
                      <h4>{stats.sliders}</h4>
                    </div>
                  </div>
                </div>
                <div className="wrap-chart">
                  <div id="line-chart-2"></div>
                </div>
              </div>
            </Link>

            <Link
              to="/inquiry"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="wg-chart-default">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap14">
                    <div className="image type-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="52"
                        viewBox="0 0 48 52"
                        fill="none"
                      >
                        <path
                          d="M19.1094 2.12943C22.2034 0.343099 26.0154 0.343099 29.1094 2.12943L42.4921 9.85592C45.5861 11.6423 47.4921 14.9435 47.4921 18.5162V33.9692C47.4921 37.5418 45.5861 40.8431 42.4921 42.6294L29.1094 50.3559C26.0154 52.1423 22.2034 52.1423 19.1094 50.3559L5.72669 42.6294C2.63268 40.8431 0.726688 37.5418 0.726688 33.9692V18.5162C0.726688 14.9435 2.63268 11.6423 5.72669 9.85592L19.1094 2.12943Z"
                          fill="#ff0000ff"
                        />
                      </svg>
                      <i className="icon-info"></i>
                    </div>
                    <div>
                      <div className="body-text mb-2">Total Inquiry</div>
                      <h4>{stats.inquires}</h4>
                    </div>
                  </div>
                </div>
                <div className="wrap-chart">
                  <div id="line-chart-2"></div>
                </div>
              </div>
            </Link>

            <Link
              to="/about-detail"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="wg-chart-default">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap14">
                    <div className="image type-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="52"
                        viewBox="0 0 48 52"
                        fill="none"
                      >
                        <path
                          d="M19.1094 2.12943C22.2034 0.343099 26.0154 0.343099 29.1094 2.12943L42.4921 9.85592C45.5861 11.6423 47.4921 14.9435 47.4921 18.5162V33.9692C47.4921 37.5418 45.5861 40.8431 42.4921 42.6294L29.1094 50.3559C26.0154 52.1423 22.2034 52.1423 19.1094 50.3559L5.72669 42.6294C2.63268 40.8431 0.726688 37.5418 0.726688 33.9692V18.5162C0.726688 14.9435 2.63268 11.6423 5.72669 9.85592L19.1094 2.12943Z"
                          fill="#ff9100ff"
                        />
                      </svg>
                      <i className="icon-file"></i>
                    </div>
                    <div>
                      <div className="body-text mb-2">About Us</div>
                      <h4>{stats.abouts}</h4>
                    </div>
                  </div>
                </div>
                <div className="wrap-chart">
                  <div id="line-chart-2"></div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
